import { NOTIFY_DEFAULTS, NOTIFY_TYPES } from '@/config/notification-config';

const EVENT_NAME = 'api-response-modal';

function emit(payload) {
  const detail = {
    ...NOTIFY_DEFAULTS,
    ...payload,
  };
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
}

export const notify = {
  success: (title, message, options = {}) =>
    emit({ type: NOTIFY_TYPES.success, title, message, ...options }),
  error:   (title, message, options = {}) =>
    emit({ type: NOTIFY_TYPES.error, title, message, ...options }),
  info:    (title, message, options = {}) =>
    emit({ type: NOTIFY_TYPES.info, title, message, ...options }),
  warning: (title, message, options = {}) =>
    emit({ type: NOTIFY_TYPES.warning, title, message, ...options }),
  alert:   (title, message, options = {}) =>
    emit({ type: NOTIFY_TYPES.warning, title, message, ...options }),
};

export const API_RESPONSE_MODAL_EVENT = EVENT_NAME;